import GoogleMapsLoader from "google-maps"

GoogleMapsLoader.KEY = "AIzaSyDG6B499ALtpiPpWcqv-6naeXWAFDRbw-w"

document.addEventListener("DOMContentLoaded", () => {
  if (!document.querySelector("[data-map]")) return

  GoogleMapsLoader.load((google) => {
    const centerCoordArr = [55.741949, 37.594689]
    const markerCoordArr = [55.741988, 37.595043]
    const centerCoord = { lat: centerCoordArr[0], lng: centerCoordArr[1] }
    const markerCoord = { lat: markerCoordArr[0], lng: markerCoordArr[1] }
    const mapEl = document.querySelector("[data-map]")
    const map = new google.maps.Map(mapEl, {
      center: centerCoord,
      zoom: 19,
      disableDefaultUI: true,
      styles: [
        {
          elementType: "geometry",
          stylers: [
            {
              color: "#f5f5f5",
            },
          ],
        },
        {
          elementType: "labels.icon",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#616161",
            },
          ],
        },
        {
          elementType: "labels.text.stroke",
          stylers: [
            {
              color: "#f5f5f5",
            },
          ],
        },
        {
          featureType: "administrative.land_parcel",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#bdbdbd",
            },
          ],
        },
        {
          featureType: "landscape",
          elementType: "geometry.stroke",
          stylers: [
            {
              color: "#bdbdbd",
            },
          ],
        },
        {
          featureType: "poi",
          elementType: "geometry",
          stylers: [
            {
              color: "#eeeeee",
            },
          ],
        },
        {
          featureType: "poi",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#757575",
            },
          ],
        },
        {
          featureType: "poi.park",
          elementType: "geometry",
          stylers: [
            {
              color: "#e5e5e5",
            },
          ],
        },
        {
          featureType: "poi.park",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#9e9e9e",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "geometry",
          stylers: [
            {
              color: "#ffffff",
            },
          ],
        },
        {
          featureType: "road.arterial",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#757575",
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "geometry",
          stylers: [
            {
              color: "#dadada",
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#616161",
            },
          ],
        },
        {
          featureType: "road.local",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#9e9e9e",
            },
          ],
        },
        {
          featureType: "transit.line",
          elementType: "geometry",
          stylers: [
            {
              color: "#e5e5e5",
            },
          ],
        },
        {
          featureType: "transit.station",
          elementType: "geometry",
          stylers: [
            {
              color: "#eeeeee",
            },
          ],
        },
        {
          featureType: "water",
          elementType: "geometry",
          stylers: [
            {
              color: "#c9c9c9",
            },
          ],
        },
        {
          featureType: "water",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#9e9e9e",
            },
          ],
        },
      ],
    })

    function Marker(latlng, map) {
      this.latlng_ = latlng
      this.setMap(map)
    }

    Marker.prototype = new google.maps.OverlayView()
    Marker.prototype.draw = function() {
      let markerEl = this.div_
      if (!markerEl) {
        markerEl = this.div_ = document.createElement("DIV")
        markerEl.classList.add("map__mark")

        const panes = this.getPanes()
        panes.overlayImage.appendChild(markerEl)
      }

      const point = this.getProjection().fromLatLngToDivPixel(this.latlng_)
      if (point) {
        markerEl.style.left = point.x + "px"
        markerEl.style.top = point.y + "px"
      }
    }

    const myLatLng = new google.maps.LatLng(markerCoord.lat, markerCoord.lng)

    // eslint-disable-next-line no-new
    new Marker(myLatLng, map)

    map.addListener("center_changed", () => {
      window.setTimeout(() => map.panTo(centerCoord), 1000)
    })

    google.maps.event.addListenerOnce(map, "tilesloaded", () => {
      $(mapEl).attr("data-map-state", "ready")
    })
  })
})



// WEBPACK FOOTER //
// ./src/blocks/map/map.js